import {
  AccountStatusType,
  DocumentActionCategoryType,
  DocumentActionType,
  ViewType,
} from '@finxone-platform/shared/sys-config-types';
import {
  CreateSavingsAccountRequest,
  PispDepositInitiateResponse,
  PispSupportedInstitution,
} from '../services/savings-account-service/savings-account.type';
import { SavingsAccountStateModel } from '../state/savings-account.state';
import { SavingsProductsStateModel } from '../state/savings-products.state';

export class GetAvailableSavingsProducts {
  static readonly type = '[SavingsAccount] GetAvailableSavingsProducts';
  constructor(
    public payload?: {
      page?: number;
      limit?: number;
      category?: string;
      clientType?: string;
      accountType?: string;
    },
  ) {}
}

export class GetNominatedAccountStatus {
  static readonly type = '[SavingsAccount] GetNominatedAccountStatus';
}

export class GetNominatedAccountDetails {
  static readonly type = '[SavingsAccount] GetNominatedAccountDetails';
  constructor(public accountId: string) {}
}

export class GetSavingAccount {
  static readonly type = '[SavingsAccount] GetSavingAccount';
  constructor(
    public page = 1,
    public limit = 10,
    public status: AccountStatusType[] = [
      AccountStatusType.active,
      // add more status types, if needed...
    ],
    public searchParams?: {
      id?: string[];
      name?: string;
      currency?: string[];
      country?: string[];
    },
    public viewType: string = ViewType.LIST,
  ) {}
}

export class GetSavingAccountDetails {
  static readonly type = '[SavingsAccount] GetSavingAccountDetails';
}

export class SetSavingLoadingStatus {
  static readonly type = '[SavingsAccount] SetSavingLoadingStatus';
  constructor(public isLoading: boolean) {}
}

export class SetSavingAccountState {
  static readonly type = '[SavingsAccount] SetSavingAccountState';
  constructor(public state: SavingsAccountStateModel) {}
}

export class UpdateActiveSavingsAccountId {
  static readonly type = '[SavingsAccount] UpdateActiveSavingsAccountId';
  constructor(public activeAccountId: string) {}
}

export class UpdateInternalTransferFromAccountId {
  static readonly type = '[SavingsAccount] UpdateInternalTransferFromAccountId';
  constructor(public accountId: string) {}
}

export class UpdateInternalTransferToAccountId {
  static readonly type = '[SavingsAccount] UpdateInternalTransferToAccountId';
  constructor(public accountId: string) {}
}

export class ClearSavingAccountCache {
  static readonly type = '[SavingsAccount] ClearSavingAccountCache';
}

export class UpdateSavingAccountName {
  static readonly type = '[SavingsAccount] UpdateSavingAccountName';
  constructor(public accountId: string, public name: string) {}
}

export class GetSupportedAispInstitutions {
  static readonly type = '[SavingsAccount] GetSupportedAispInstitutions';
  constructor(public country: string) {}
}

export class SetPispDepositInitiateResponse {
  static readonly type = '[SavingsAccount] SetPispDepositInitiateResponse';
  constructor(public response: PispDepositInitiateResponse) {}
}

export class SetSupportedPispInstitutions {
  static readonly type = '[SavingsAccount] SetSupportedPispInstitutions';
  constructor(public institutions: PispSupportedInstitution[]) {}
}

export class GetSupportedPispInstitutions {
  static readonly type = '[SavingsAccount] GetSupportedPispInstitutions';
  constructor(
    public country: string,
    public feature?: string,
  ) {}
}

export class UpdateSavingAccountNameInFormState {
  static readonly type = '[SavingsAccount] UpdateSavingAccountNameInFormState';
  constructor(public accountId: string) {}
}

export class GetSavingAccountDocumentDetails {
  static readonly type = '[Account] GetSavingAccountDocumentDetails';
  constructor(
    public documentContext: DocumentActionType,
    public documentCategory: DocumentActionCategoryType,
    public accountId: string,
  ) {}
}

export class GetAccountRequests {
  static readonly type = '[SavingsAccount] GetAccountRequests';
}

export class SetSavingProductsState {
  static readonly type = '[SavingsProducts] SetSavingProductsState';
  constructor(public state: SavingsProductsStateModel) {}
}

export class CreateSavingsAccount {
  static readonly type = '[SavingsAccount] CreateSavingsAccount';
  constructor(public payload: CreateSavingsAccountRequest) {}
}

export class RefreshActiveAccountDetails {
  static readonly type = '[SavingsAccount] RefreshActiveAccountDetails';
  constructor(public accountId: string) {}
}

export class FetchJointAccountRequests {
  static readonly type = '[SavingsAccount] FetchJointAccountRequests';
}
